export default "__VITE_ASSET__BubFfynJ__"